module.exports = __webpack_public_path__ + "img/20190813160416331.c3ce45ee.png";